// extracted by mini-css-extract-plugin
export default {"viewToggle":"ViewToggle_viewToggle__JaovB","toggleButton":"ViewToggle_toggleButton__h8h3o","active":"ViewToggle_active__TaIa6"};